import { Button } from 'antd';

import './EditButton.scss';

type Props = {
  onClick: () => void;
};

export const EditButton = ({ onClick }: Props) => (
  <div className="booking-edit-btn">
    <Button size="large" onClick={onClick}>
      Edit
    </Button>
  </div>
);
